import { useEffect } from 'react';

/**
 * Takes in a callback to execute when escape key is pressed
 * @param {function} cb - Callback function to execute when escape key is presesed
 * @param {array} deps - Dependencies for the hook (e.g. ref)
*/

var useEscape = function useEscape(cb) {
  var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  useEffect(function () {
    var escape = function escape(e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        cb();
      }
    };

    window.addEventListener('keydown', escape, false);
    return function () {
      window.removeEventListener('keydown', escape, false);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};

export default useEscape;
